export const UserTypes = {
  GET_PREFERENCE: "USER::GET_PREFERENCE", //not used - but prefs are stored somehow...
  GET_INFO: "USER::GET_INFO",
  GET_INFO_SUCCESS: "USER::GET_INFO_SUCCESS",
  GET_INFO_FAILED_404: "USER::GET_INFO_FAILED_404",
  SET_AUTH_TOKEN: "USER::SET_AUTH_TOKEN",
  CLEAR_USER: "USER::CLEAR_USER",
};
